import type { SelectField } from '@payloadcms/plugin-form-builder/types'
import type { Control, FieldErrorsImpl } from 'react-hook-form'
import React from 'react'
import { Controller } from 'react-hook-form'

import { Error } from './Error'

export const Select: React.FC<
  SelectField & { control: Control; errors: Partial<FieldErrorsImpl> }
> = ({ name, control, errors, label, options, required, defaultValue }) => {
  return (
    <div className="field">
      <label htmlFor={name}>
        {label}
        {required && ' *'}
      </label>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        rules={{ required }}
        render={({ field: { onChange, value } }) => (
          <select id={name} value={value ?? ''} onChange={(e) => onChange(e.target.value)}>
            <option value="" disabled>
              {label}
            </option>
            {options.map(({ label: optionLabel, value: optionValue }) => (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            ))}
          </select>
        )}
      />
      {errors[name] && <Error name={name} />}
    </div>
  )
}
